import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useRef, useState } from 'react';
import BaseModal from '../ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';
import BaseInput from '../ui-components/BaseInput';
import BaseTextArea from '../ui-components/BaseTextArea';
import Icon from '../ui-components/Icon';
import { createRoomSession, setRoomImage, updateChatSession } from 'flow/actions/chat-actions';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { generatePath, useHistory } from 'react-router-dom';
import { routes } from 'flow/types/routes';
import { roomTypes } from 'flow/pages/messages/MessageInput';
import { twMerge } from 'tailwind-merge';
import { List, Map, fromJS } from 'immutable';
import useExtension from 'flow/hooks/useExtension';
import useAutoFocus from 'flow/hooks/useAutoFocus';
import { getChatRoomAvatar } from '../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var defaultValue = {
  attachment: null,
  title: '',
  description: '',
  imageSrc: ''
};
var ManageRoomModal = function ManageRoomModal(_ref) {
  var sessionKey = _ref.sessionKey,
    editRoom = _ref.editRoom,
    _ref$chosenExtensions = _ref.chosenExtensions,
    chosenExtensions = _ref$chosenExtensions === void 0 ? List() : _ref$chosenExtensions,
    header = _ref.header,
    confirmButtonText = _ref.confirmButtonText;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var dispatch = useAppDispatch();
  var fileInputRef = useRef(null);
  var _useExtension = useExtension(),
    ownExtension = _useExtension.ownExtension;
  var session = useAppSelector(function (state) {
    return state.chats.getIn(['sessions', sessionKey], Map());
  });
  var editValue = {
    attachment: null,
    imageSrc: session.get('roomImageResource') ? getChatRoomAvatar(session === null || session === void 0 ? void 0 : session.get('roomImageResource')) : '',
    title: session.get('name'),
    description: session.get('roomDescription')
  };
  var _useState = useState(editRoom ? editValue : defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    roomContent = _useState2[0],
    setRoomContent = _useState2[1];
  var handleAttachment = function handleAttachment(attachment) {
    if (attachment) {
      var reader = new FileReader();
      reader.readAsDataURL(attachment);
      reader.onloadend = function () {
        setRoomContent(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            imageSrc: reader.result.toString(),
            attachment: attachment
          });
        });
      };
    }
  };
  var history = useHistory();
  var handleSubmit = function handleSubmit() {
    var onSuccess = function onSuccess(chatSessionKey) {
      return history.push(generatePath(routes['messages.id.settings'], {
        id: chatSessionKey
      }));
    };
    if (!chosenExtensions.isEmpty()) {
      chosenExtensions.push(ownExtension);
      var chatUserKeys = chosenExtensions.map(function (extension) {
        return Map({
          key: extension.get('chatUserKey')
        });
      });
      var sessionDTO = fromJS({
        name: roomContent.title,
        roomDescription: roomContent.description,
        roomType: roomTypes.room,
        members: chatUserKeys
      });
      dispatch(createRoomSession(sessionDTO, roomContent.attachment, onSuccess));
    } else {
      var _sessionDTO = {
        key: sessionKey,
        roomType: roomTypes.room,
        name: roomContent.title,
        roomDescription: roomContent.description,
        members: session.get('members')
      };
      if (editRoom) {
        dispatch(updateChatSession(sessionKey, _sessionDTO));
        if (roomContent.attachment) {
          dispatch(setRoomImage(sessionKey, roomContent.attachment));
        }
      } else {
        dispatch(createRoomSession(_sessionDTO, roomContent.attachment, onSuccess));
      }
    }
  };
  var inputRef = useAutoFocus();
  return /*#__PURE__*/_jsx(BaseModal, {
    open: true,
    header: header,
    onSubmit: handleSubmit,
    confirmButtonText: confirmButtonText,
    disableSubmit: !roomContent.title,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col gap-5",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-x-3",
        children: [/*#__PURE__*/_jsx("div", {
          className: twMerge('flex items-center justify-center rounded-2xl bg-gray-200', !chosenExtensions.isEmpty() ? 'size-9' : 'size-14'),
          children: roomContent.imageSrc ? /*#__PURE__*/_jsx("img", {
            src: roomContent.imageSrc,
            alt: i18next.t('Chat.Room.Picture'),
            className: "h-full rounded-2xl object-cover"
          }) : /*#__PURE__*/_jsx(Icon, {
            iconKey: 'image',
            className: "text-gray-400"
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: twMerge('cursor-pointer rounded-sm hover:bg-gray-300', !chosenExtensions.isEmpty() ? null : 'bg-gray-200'),
          onClick: function onClick() {
            return fileInputRef.current.click();
          },
          children: [/*#__PURE__*/_jsx("input", {
            ref: fileInputRef,
            type: "file",
            className: "hidden",
            onChange: function onChange(e) {
              var _e$target;
              handleAttachment((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0]);
              e.target.value = null;
            },
            accept: "image/*"
          }), /*#__PURE__*/_jsx("p", {
            className: "p-2 text-sm/4 font-medium",
            children: editRoom ? i18next.t('Chat.Tooltip.Change.Image') : i18next.t('Chat.Tooltip.Image')
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex w-full flex-col gap-y-1.5",
        children: [/*#__PURE__*/_jsx("label", {
          htmlFor: "title",
          className: "text-xs text-gray-800",
          children: i18next.t('Chat.Public.Create.Name.Title')
        }), /*#__PURE__*/_jsx(BaseInput, {
          onChange: function onChange(e) {
            var _e$target2;
            var title = (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value;
            setRoomContent(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                title: title
              });
            });
          },
          value: roomContent.title,
          ref: inputRef,
          maxLength: 32,
          id: "title"
        })]
      }), /*#__PURE__*/_jsx(BaseTextArea, {
        label: i18next.t('Chat.Public.Create.Description.Title'),
        value: roomContent.description,
        onChange: function onChange(e) {
          var _e$target3;
          var description = (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.value;
          setRoomContent(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              description: description
            });
          });
        },
        maxLength: 255,
        id: "description"
      }), !chosenExtensions.isEmpty() && /*#__PURE__*/_jsx("p", {
        className: "w-4/5 text-xs text-gray-500",
        children: i18next.t('chat.create_room_help')
      })]
    })
  });
};
export default ManageRoomModal;